import { useUserAuth } from 'contexts/UserAuth';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import Modal from 'react-modal';

const BaseInfoReminderModal = () => {
  const router = useRouter();
  const { user, isSignInStatusReady, isAnonymous } = useUserAuth();
  const [show, setShow] = useState(false);
  const [countDown, setCountDown] = useState(0);

  useEffect(() => {
    const excludedPaths = ['/question', '/complete', '/email'];
    const isExcludedPath = excludedPaths.some((path) =>
      router.pathname.startsWith(path)
    );

    // console.log('[BaseInfoReminderModal] Debug:', {
    //   isSignInStatusReady,
    //   user,
    //   base_information_filled: user?.base_information_filled,
    //   post_signup_questionnaire_filled: user?.post_signup_questionnaire_filled,
    //   pathname: router.pathname,
    //   isExcludedPath,
    // });

    if (
      isSignInStatusReady &&
      user &&
      user.base_information_filled === false &&
      !isExcludedPath &&
      !isAnonymous
    ) {
      const now = Date.now();
      const lastShownTime = localStorage.getItem('sorra_base_info_popup_time');
      const storedLoginAt = localStorage.getItem('sorra_base_info_login_at');
      const currentLoginAt = user.last_login_at;

      // console.log('[BaseInfoReminderModal] Condition passed:', {
      //   now,
      //   lastShownTime,
      //   storedLoginAt,
      //   currentLoginAt,
      // });

      // 第一次 或 重新登入（登入時間改變）：開始倒數
      if (!lastShownTime || storedLoginAt !== currentLoginAt) {
        setCountDown(10);
      } else {
        // 之後：檢查是否超過 10 分鐘
        const timeSinceLastShown = (now - parseInt(lastShownTime)) / 1000;
        if (timeSinceLastShown > 600) {
          setCountDown(10);
          // localStorage.setItem('sorra_base_info_popup_time', now.toString());
        }
      }
    }
  }, [isSignInStatusReady, user, router.pathname, isAnonymous]);

  useEffect(() => {
    if (countDown > 0) {
      const timer = setTimeout(() => {
        if (countDown === 1) {
          const now = Date.now();
          localStorage.setItem('sorra_base_info_popup_time', now.toString());
          localStorage.setItem('sorra_base_info_login_at', user?.last_login_at);
          setShow(true);
        }
        setCountDown((prev) => prev - 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [countDown, user?.last_login_at]);

  const close = () => {
    setShow(false);
  };

  const goToQuestion = () => {
    setShow(false);
    router.push('/question?step=4');
  };

  return (
    <Modal
      isOpen={show}
      onRequestClose={close}
      shouldCloseOnOverlayClick={true}
      className="font-notoSanaTC relative mx-4 w-full max-w-[400px] rounded-2xl bg-white px-4 pb-4 pt-8 outline-none"
      style={{
        content: {
          boxShadow: 'rgba(0, 0, 0, 0.16) 0px 24px 48px',
        },
      }}
      overlayClassName="fixed inset-0 z-[70] flex items-center justify-center bg-black/50"
    >
      <button
        onClick={close}
        className="hover:cursor-point absolute right-6 top-2 text-[24px] font-bold text-gray-800 hover:text-gray-600"
      >
        &times;
      </button>

      <div className="flex flex-col items-center text-center">
        <h2 className="text-[18px] font-bold text-[#111928]">
          {user && user.post_signup_questionnaire_filled === true
            ? '獲取更精準的個人化內容！ 💗'
            : '設定你的基本資料 💗 可獲5分！'}
        </h2>

        <p className="mt-3 text-[14px] text-[#4A4A4A]">
          {user && user.post_signup_questionnaire_filled === true
            ? `填寫性別與出生年份，幫助 Sorra
          在你搜尋產品時，提供更貼合你膚質與年齡層的分析與建議！`
            : '完成後可獲得5分，解鎖留言功能，並兌換豐富禮品！'}
        </p>

        <div className="mt-6 flex w-full gap-3">
          <button
            onClick={close}
            className="h-12 flex-1 rounded-lg border border-sorra-pink bg-white text-sorra-pink"
          >
            稍後提醒我
          </button>
          <button
            onClick={goToQuestion}
            className="h-12 flex-1 rounded-lg bg-sorra-pink text-white"
          >
            立即設定
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default BaseInfoReminderModal;
